import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import Grid from '@mui/material/Grid2';

import { 
  ModelBase,
} from "@models";
import { 
  Deity, 
  GameClass,
  Alignment
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import LoadingBox from "@components/input/LoadingBox";
import ModelBaseInput from "@dndComponents/ModelBaseInput";
import SuggestionStringBox from "@dndComponents/select/SuggestionStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import SelectAlignmentBox from "@dndComponents/select/SelectAlignmentBox";
import SelectCreatureBox from "@dndComponents/select/SelectCreatureBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function DeityEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<Deity>(api.applyWorkingOn(new Deity()));
  const [cleric_classes, setClericClasses] = useState<string[]>([]);
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setLoading(true);
    api.getObjectsWithVersions({ data_type: "game_class", filter: { name: "Cleric" }}).then(res => {
      setClericClasses((res as GameClass[]).map(o => o._id));
      if (id && id !== "") {
        api.getFullObject("deity", id).then(res2 => {
          if (res2) {
            setObj(res2 as Deity);
            setLoading(false);
          }
        });
      } else {
        setLoading(false);
      }
    });
    setFetched(true);
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("deity", obj).then(res => {
  //       console.log(res);
  //       if (res && res.body.id) {
  //         obj._id = res.body.id;
  //       } 
  //       setProcessing(false);
  //       setNavigateTo("/dandd/deity");
  //     });
  //   }
  // }
  
  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else {
    return (
      <ModelBaseInput
        obj={obj}
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: ModelBase) => {
          if (changed instanceof Deity) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <SelectAlignmentBox
              name="Alignment"
              value={obj.alignment}
              onChange={(changed: Alignment) => {
                const new_obj = obj;
                new_obj.alignment = changed;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SuggestionStringBox 
              name="Settings"
              field="settings"
              values={obj.settings}
              multiple
              onChange={(values: string[]) => {
                const new_obj = obj;
                new_obj.settings = values;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SuggestionStringBox 
              name="Native Planes"
              field="native_planes"
              values={obj.native_planes}
              multiple
              onChange={(values: string[]) => {
                const new_obj = obj;
                new_obj.native_planes = values;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectObjectBox
              name="Divine Domains"
              data_type="subclass"
              filter={{ game_class_id: { "$in": cleric_classes } }}
              multiple
              values={obj.divine_domains}
              onChange={(values: string[]) => {
                const new_obj = obj;
                new_obj.divine_domains = values;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectCreatureBox
              name="Associated Creatures"
              multiple
              values={obj.associated_creatures}
              onChange={(values: string[]) => {
                const new_obj = obj;
                new_obj.associated_creatures = values;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
        </Grid>
      </ModelBaseInput>
    );
  }
}